import React from 'react';

function ArrowRight() {
    return (
        <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 5H3.5C3.22 5 3 4.78 3 4.5C3 4.22 3.22 4 3.5 4H12.5C12.78 4 13 4.22 13 4.5C13 4.78 12.78 5 12.5 5Z"
                fill="#3AA9F5"
            />
            <path
                d="M10 8.49998C9.93442 8.50078 9.86941 8.48785 9.80913 8.46201C9.74885 8.43618 9.69465 8.39802 9.65 8.34998C9.45 8.14998 9.45 7.83998 9.65 7.63998L12.8 4.48998L9.65 1.33998C9.45 1.13998 9.45 0.82998 9.65 0.62998C9.85 0.42998 10.16 0.42998 10.36 0.62998L13.86 4.12998C14.06 4.32998 14.06 4.63998 13.86 4.83998L10.36 8.33998C10.26 8.43998 10.13 8.48998 10.01 8.48998L10 8.49998Z"
                fill="#3AA9F5"
            />
        </svg>
    );
}

export default ArrowRight;